/**
 * AFK taglines — sarcastic one-liners shown across the app (login screen,
 * footer, header tooltip, PDF cover page). Keep each under 70 characters
 * so they don't blow out narrow layouts. Used by both the worker (PDF
 * cover) and the React app, hence the shared module.
 */

export const TAGLINES: readonly string[] = [
  "Out of office. Out of patience.",
  "Currently negotiating with a hammock.",
  "On vacation. Reply hazy, ask again later.",
  "Slack? I hardly know her.",
  "Status: physically present, spiritually elsewhere.",
  "Mentally on a beach since approximately 2019.",
  "PTO: Permanently Thinking Of Otherwhere.",
  "I am out of office. Specifically, several time zones out.",
  "Auto-reply: lol no.",
  "Pretending to read your email very soon.",
  "Catch you on the flip flop.",
  "Currently buffering. Try again Monday.",
  "Booked, blessed, and unbothered.",
  "Vacation: the ancient ritual of sunburn and email guilt.",
  "Looks like leave o'clock somewhere.",
  "Currently crushing a no-laptop-on-the-deck policy.",
  "Sorry, your email is in another castle.",
  "If found, please return to the swim-up bar.",
  "Calendar status: extremely declined.",
  "Inbox declared bankruptcy. Going to get tacos.",
  "Hi, you've reached AFK. Press 1 to envy us.",
  "On a quest to remember what hobbies are.",
  "Doing my part to use the floor balance.",
  "Use it or lose it. Mostly use it.",
  "Approving my own time off again.",
  "Sun's out, Slack's off.",
  "Emails will be read in chronological order. Of next quarter.",
  "Working remotely. Definition of 'working' is flexible.",
  "Replying to this is on my to-do list. Which is at home.",
  "Filing my time sheet under 'no'.",
  "Spending the day teaching the cat about deadlines.",
  "Currently on assignment investigating brunch.",
  "Out chasing a deer. Or a beer. Same energy.",
  "Be right back. Just need to find the wifi password to a hammock.",
  "I'll get back to you in a season or two.",
  "If this is urgent, please reconsider what 'urgent' means.",
  "Put on my OOO and somehow it fits perfectly.",
  "Doing the very serious work of doing nothing.",
  "Checked out. Spiritually, emotionally, calendrically.",
  "Tracking vacation so I don't accidentally work my whole life.",
  "PTO planner: enabled. PTO usage: aspirational.",
  "Just a guy and his accrual rate.",
  "Off the grid. Mostly off the lawn chair.",
  "I am away from keyboard. The keyboard is at peace.",
  "Tipping the work-life scale by sitting on the work side.",
  "Came back tan, stayed sarcastic.",
  "Currently 0% available, 100% available for vibes.",
  "Vacation status: pending in my head, approved in my heart.",
  "Living the dream. Spreadsheet attached.",
  "Off doing important not-work.",
  "Adding sunscreen to the project plan.",
  "Booked time off because the alternative is unbookable.",
  "Vacation policy compliance officer. Off duty.",
  "Logging hours of nothing. Productive nothing.",
  "OOO and proud.",
  "Burning floor before HR makes me.",
  "Just here to watch the calendar fill up.",
  "Vacation tracker: powered by spite and sunscreen.",
  "Today's deliverable: a tan line.",
  "Out trying to remember the password to my own life.",
  "Approving leave faster than my manager.",
  "Schedule cleared. Conscience clearer.",
  "Time off: where the magic and the laundry happens.",
  "Got 99 problems but a meeting ain't one.",
  "Replying to nothing in particular.",
  "On vacation. Possibly forever. Send sunscreen.",
  "Be advised: I am brunching.",
  "Working hard at not working hard.",
  "Calendar's blocked. So is my will to log in.",
  "Out of office until further notice from my dog.",
  "The only standup I'm attending is the paddleboard.",
  "Status: exquisitely unavailable.",
  "Doing a planned, scheduled, fully approved nothing.",
  "Currently buffering.",
  "Trying to get my carryover under control. By using it.",
  "Vacation? I prefer 'fiscal recovery'.",
  "Sand in shoes, peace in heart.",
  "Auto-reply has more personality than the original message.",
  "Got my OOO loaded and locked.",
  "Burnout reduction in progress.",
  "Today's stretch goal: a stretch.",
  "The CEO of taking days off.",
  "Look at me. I am the project manager now.",
  "Conditional approval: condition was 'me deciding'.",
  "I'll be unreachable. Like, 5G unreachable.",
  "Be back in two weeks or one good idea, whichever first.",
  "I have entered the chat. Of doing nothing.",
  "OOO: Operating Outside Outlook.",
  "Sorry I missed your meeting. Not really.",
  "The road less Slacked.",
  "My out-of-office is on. So is my Crocs.",
  "Currently on a personal sabbatical from my own opinions.",
  "Email me a postcard.",
  "Today is brought to you by the letters PTO.",
  "Status: airplane mode for my soul.",
  "Brain on autoreply.",
  "If you can read this, I'm not.",
  "Remote means remote. As in another continent.",
  "You miss 100% of the meetings you decline.",
  "Be right back, doing my taxes... in Mexico.",
  "Ducked out. Ducks involved.",
  "Just used a vacation day to plan a vacation.",
  "Manager? Auto-approver of my dreams.",
  "Don't worry, I left detailed instructions: figure it out.",
  "Pour one out for the unread email.",
  "Spreadsheet of my hopes and dreams: tab 2 says 'Maui'.",
  "Watering my plants and my calendar.",
  "Currently AFK, also FFS, also IDK.",
  "If found, please water and reschedule.",
  "Out of office. In office of self.",
  "Tide is high, and so are my expectations.",
  "Putting the 'cation' back in vacation.",
  "OOO: Officially On Otherwhere.",
  "Hammocks don't lie.",
  "Putting on my flip flops with intention.",
  "Out and about. Mostly about not being in.",
  "Doing absolutely zero on purpose.",
  "Resting bossly.",
  "Tan now. Email later.",
  "Productivity coach approved this nap.",
  "Doing my bit to keep the airline industry alive.",
  "OOO: bored. JK, having a great time.",
  "The only ticket I'm closing is at the airport.",
  "Spreadsheet says I have 4.25 days. I'm taking 5.",
  "Time off is the new networking event.",
  "Stand-up canceled, sit-down expanded.",
  "Doing the noble work of being unreachable.",
  "Floor balance: melting. Like ice cream.",
  "I left my heart at the calendar settings page.",
  "Look mom, I made it onto the OOO.",
  "Hi, your email has been forwarded to my heart's contents.",
  "Currently A-F-K-ing very specifically.",
  "Phoning it in. From a phone, ironically off.",
  "Status: Schrödinger's employee.",
  "Don't hate the player, hate the PTO policy.",
  "If you need me, I'll be in the past tense.",
  "Pretending to be a gardener for the week.",
  "Today I am professionally horizontal.",
  "Floor balance vs. sanity: I choose sanity.",
  "Schedule: Wide open, like my snack drawer.",
  "Out for the foreseeable. The unforeseeable too.",
  "Vacation: where the laundry comes home different.",
  "Charge cycle in progress. ETA: a week.",
  "On the job market for couches.",
  "Currently rebooting my soul.",
  "Out of office, into ocean.",
  "I'll respond to your email by gut feeling, eventually.",
  "Approved: my own audacity.",
  "Step one: take vacation. Step two: there is no step two.",
  "Email: read. Acted upon: don't be silly.",
  "Pulling a hat trick: PTO, PTO, and more PTO.",
  "Booking flights, ignoring meetings.",
  "Calendar's screaming. So am I, but at a beach.",
  "I came, I saw, I PTO'd.",
  "Did I take a sick day? Define sick. Define day.",
  "Practicing the ancient art of doing nothing on purpose.",
  "OOO until I remember why I logged in.",
  "Currently emotionally on PTO regardless of status.",
  "Be right back, building a sandcastle moat.",
  "Today's KPI: zero.",
  "Manager: thumbs up. Me: book signal.",
  "Yes I planned this. Yes I'm proud.",
  "Putting the 'fun' in 'unfunded mandate'. Wait, wrong.",
  "Floor balance is screaming at me. So I'm screaming back.",
  "Channeling my inner couch.",
  "Taking PTO so I can buy more PTO.",
  "Achievement unlocked: did not check email.",
  "Vacation responsibly. Or don't.",
  "I'm out, like a light.",
  "Replying once I get back from getting back.",
  "Trip planned. Snacks packed. Out.",
  "On a fact-finding mission. Fact: I'm tired.",
  "Tickets purchased. Apologies pre-loaded.",
  "Boss approved. Body unconvinced. Going anyway.",
  "Eating snacks for several time zones.",
  "Just here to water the OOO message.",
  "Ringing in the new fiscal year with PTO.",
  "Running on accrual. And caffeine.",
  "Catch flights, not feelings.",
  "Currently a feature, not a bug.",
  "Headed somewhere, finally.",
  "All systems no.",
  "Vacation is the first draft of retirement.",
  "Quarter end? Quarter beach.",
  "Booked off. Like a library card.",
  "Sorry, I gave my keyboard the day off.",
  "Calendar opened. Calendar closed.",
  "BRB taking a nap on a different continent.",
  "Quiet, my email is dreaming.",
  "Today's special: nothing, with a side of nothing.",
  "Powered by trail mix and disinterest.",
  "OOO season. Like flu, but better.",
  "Planning to be unplanned.",
  "Floor balance: diminished. Spirits: lifted.",
  "Out to lunch. For three days.",
  "Headphones on, Slack off.",
  "I left my desk on read.",
  "Yes, that's a vacation entry. No, you can't have it.",
  "Status: passively delightful.",
  "Currently fighting Greg in accounting via auto-reply.",
  "You earned this. Even if HR didn't say so.",
  "Floor balance walked so I could run.",
  "Vacation policy: enthusiastic compliance.",
  "If you need me, find a beach and yell.",
  "Approval pending: from me, to me, by me.",
  "PTO: Pretty Tasty Outdoors.",
  "Off the clock and on a roll.",
  "Burning leave and bridges. Mostly leave.",
  "Working from beach. Tomorrow. Forever, ideally.",
  "Calendar reads: 'do not perceive me'.",
  "Doing the bare minimum, gloriously.",
  "Out. Out out.",
];

/** Return a single tagline. Deterministic when seeded with a string. */
export function pickTagline(seed?: string | number): string {
  if (seed === undefined) return TAGLINES[Math.floor(Math.random() * TAGLINES.length)]!;
  let h = 0;
  const s = String(seed);
  for (const ch of s) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return TAGLINES[h % TAGLINES.length]!;
}
